/* eslint-disable no-param-reassign */
import angular from 'angular';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  pet: state.pet.pet,
  petId: state.pet.activePetId,
  transactions: state.transaction.petTransactions,
  media: state.media.petMedia,
  petOwner: state.user.user,
  activeOrganization: state.organization.activeOrganization,
  isAdminUser: state.auth.isAdminUser,
  originalBreedList: state.pet.breeds,
});

angular
  .module('myConsultApp')
  .controller('petDetailController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.tabId = 'pet-information';

    $scope.close = () => {
      $rootScope.clearAdminPet();
      $scope.clearPetDetail();
      $rootScope.closeComponent();
    };

    $scope.generatebeforeRoute = () => {
      return `${$rootScope.routes.user}/${$rootScope.userId}/pet-detail/${$rootScope.adminPetId}`;
    };

    $scope.generatecloseRoute = () => {
      return $rootScope.previousRoute || `${$rootScope.routes.user}/${$rootScope.userId}`;
    };

    $scope.petDetailTabChanges = debounce((event, tabId) => {
      const indicator = document.querySelector('.pet-detail-info .vertical-tab-bar .indicator');
      const tabs = document.querySelectorAll('.pet-detail-info .vertical-tab-bar .tab');
      let i = 0;
      if (event) {
        for (; i < tabs.length; i++) {
          if (tabs[i] === event.currentTarget) {
            break;
          }
        }
      }

      indicator.style.marginTop = `${i * tabs[0].offsetHeight}px`;

      $scope.$apply(() => {
        $scope.tabId = tabId;
      });
    }, 100);

    $scope.clearPetDetail = () => {
      $scope.isPetActionMenu = false;
      $scope.pet_information = {
        status: {
          label: 'Status',
          value: null,
          order: 0,
        },
        gender: {
          label: 'Gender',
          value: null,
          order: 1,
        },
        species: {
          label: 'Species',
          value: null,
          order: 2,
        },
        breed: {
          label: 'Breed',
          value: null,
          order: 3,
        },
        date_created: {
          label: 'Date Created',
          value: null,
          order: 4,
        },
        date_updated: {
          label: 'Date Updated',
          value: null,
          order: 5,
        },
        date_of_birth: {
          label: 'Date of Birth',
          value: null,
          order: 6,
        },
        age: {
          label: 'Age',
          value: null,
          order: 7,
        },
        human_age: {
          label: 'Human Age',
          value: null,
          order: 8,
        },
        lifestage: {
          label: 'Lifestage',
          value: null,
          order: 9,
        },
        adoption_date: {
          label: 'Date Adopted',
          value: null,
          order: 10,
        },
      };
      $scope.medical_information = {
        sterilized: {
          label: 'Sterilized',
          value: null,
          order: 0,
        },
        medical_conditions: {
          label: 'Medical Conditions',
          value: [],
          order: 1,
        },
        family_medical_conditions: {
          label: 'Family Medical Conditions',
          value: [],
          order: 2,
        },
        owner_identification: {
          label: 'Owner Identification',
          value: [],
          order: 3,
        },
        declawed: {
          label: 'Declawed Status',
          value: null,
          order: 4,
        },
        notes: {
          label: 'Notes',
          value: null,
          order: 6,
        },
        weight: {
          label: 'Weight',
          value: null,
          order: 7,
        },
      };
      $scope.provider_information = [];
      $scope.petDetailTable = null;
      if ($scope.tabId !== 'pet-information') {
        $scope.tabId = 'pet-information';
        $scope.petDetailTabChanges(null, $scope.tabId);
      }
    };

    $scope.clearPetDetail();

    $scope.setTable = () => {
      $scope.petDetailTable = {
        name: `Activities Related to ${$rootScope.adminPet.name}`,
        options: {
          endpoint: `/2.0/users/${$rootScope.userId}/user-activities/`,
          endpoint_data_key: 'user-activities',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'activity',
          scale_up: true,
          search_key: null,
          id_prefix: 'petactivities',
          default_parameters: { pets: $rootScope.adminPet.id },
        },
        actions: [],
        columns: [
          {
            name: 'Activity Date',
            options: {
              content: '{{ record.activity_date }}',
              class: '',
            },
          },
          {
            name: 'Activity Type',
            options: {
              content:
                '{{ ["Media", "Promotion Code", "Redemption", "Transaction", "Journey"].includes(record.activity_type) ? record.activity_type : record.activity_name }}' +
                '<br ng-if="record.activity_type == \'Journey\'" /><span ng-if="record.activity_type == \'Journey\'">Tracked:</span> <span ng-if="record.activity_type == \'Journey\'" class="bold italic">{{ record.activity.title }}</span>',
              class: '',
            },
          },
          {
            name: 'Activity Points',
            options: {
              content:
                '{{ record.num_points || 0 }}' +
                '<span ng-if="record.redemption && record.redemption.status.id < -2" class="bold italic pending">(pending)</span>' +
                '<span ng-if="record.transaction && record.transaction.status.id == 1" class="bold italic pending">(pending)</span>',
              class: '',
            },
          },
          {
            name: 'Additional Details',
            options: {
              content:
                '<div ng-if="record.media && record.media.length" class="media-additional-detail"><div class="media-id"><span class="bold italic">Media Count:</span> {{ record.media.length }}</div>' +
                '<div class="pet-info" ng-if="record.media.pets"><div class="italic">for</div><div ng-repeat="pet in record.media.pets"><a ng-click="onSelectPet({petId: pet.id})" href="#">{{ pet.name }}</a></div>' +
                '</div></div>' +
                '<div ng-if="record.redemption"><span class="bold italic">Redemption ID:</span> {{record.redemption.id }}</div>' +
                '<div ng-if="record.transaction"><span class="bold italic">Transaction ID:</span> {{ record.transaction.id }}' +
                '<span class="bold italic" ng-if="record.transaction.status == 1">(submitted)</span></div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media"><span class="bold italic">Activity ID:</span> {{ record.id }}</div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media && record.user_activity_id"><span class="bold italic">User Activity ID:</span> {{ record.user_activity_id }}</div>',
              class: '',
            },
          },
          {
            name: 'Notes',
            options: {
              content:
                // '<div ng-if="record.activity_type == \'Journey\'" class="detail-content"><div><a href="#" ng-click="showJourneyDetail(record)">View Journey Details</a></div></div>' +
                '<div ng-if="record.media" class="detail-content"><div><a href="#" ng-click="showMediaDetail({media: record.media, userId: record.user.id})">View Media Details</a></div></div>' +
                '<div ng-if="record.activity_type == \'Promotion Code\'" >{{ record.activity_name }}<br />{{ record.activity_description }}</div>' +
                '<div ng-if="record.redemption" ><a href="#" ng-click="showRedemptionDetail({redemptionId: record.redemption.id, beforeRoute: generatebeforeRoute(), closeRoute: generatecloseRoute()})">View Redemption Details</a></div>' +
                '<div ng-if="record.transaction" ><a href="#" ng-click="showTransactionDetail({transactionId: record.transaction.id, beforeRoute: generatebeforeRoute(), closeRoute: generatecloseRoute()})">View Transaction Details</a></div>' +
                '<div ng-if="!record.transaction && !record.redemption && !record.media" class="default-note">{{ record.notes }}</div>',
              class: '',
            },
          },
        ],
        filters: [
          {
            name: 'Activity Types',
            type: 'multiple_choice',
            options: {
              choices: {
                Media: { state: true, value: 'media', order: 0 },
                'Promotion Codes': { state: true, value: 'promotion_codes', order: 1 },
                Transactions: { state: true, value: 'transactions', order: 2 },
                Redemptions: { state: true, value: 'redemptions', order: 3 },
                Journeys: { state: true, value: 'journey', order: 4 },
                'Member Tiers': { state: true, value: 'member_tier', order: 5 },
                'Other Point-Based Activities': {
                  state: true,
                  value: 'other_point_based_activities',
                  order: 6,
                },
                'Authorized Users': { state: true, value: 'authorized_user', order: 7 },
                'Inbox Messages': { state: true, value: 'inbox_message', order: 8 },
                Other: { state: true, value: 'other', order: 9 },
              },
              class: 'activity-type-filter',
              query_string_parameter: 'data_type',
              select_all: true,
            },
          },
          {
            name: 'Point Adjustments',
            type: 'single_choice',
            options: {
              choices: {
                All: { type: 'standard', state: true, value: 'all', order: 0 },
                'Only Adjustments': {
                  type: 'standard',
                  state: false,
                  value: 'adjustments',
                  order: 1,
                },
                'Only Credits': { type: 'standard', state: false, value: 'credits', order: 2 },
                'Only Debits': { type: 'standard', state: false, value: 'debits', order: 3 },
                'Custom Amount': {
                  type: 'amount',
                  state: false,
                  value: 'amount',
                  amount: '',
                  date_field: false,
                  order: 4,
                  error: false,
                },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: false,
                  order: 5,
                  error: false,
                },
              },
              class: 'point-adjustments-filter',
              query_string_parameter: 'point_adjustment',
            },
          },
          {
            name: 'Timeframe',
            type: 'single_choice',
            options: {
              choices: {
                'Last 24 Hours': { type: 'standard', state: true, value: 'day', order: 0 },
                'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
                'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
                All: { type: 'standard', state: false, value: 'all', order: 3 },
                'Custom Range': {
                  type: 'range',
                  state: false,
                  value: 'range',
                  from: '',
                  to: '',
                  date_field: true,
                  order: 4,
                  error: false,
                },
              },
              class: 'timeframe-filter above-divider',
              query_string_parameter: 'timeframe',
            },
          },
          {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
          },
          {
            name: 'Activity Status',
            type: 'multiple_choice',
            options: {
              choices: {},
              choices_endpoint: '/2.0/user-activities/statuses/?paginate=false',
              choices_endpoint_data_key: 'user-activity-statuses',
              class: 'scroll-choices above-divider',
              name_attribute: 'name',
              no_selected_parameter: 'none',
              query_string_parameter: 'status',
              select_all: true,
            },
          },
        ],
        sort_options: {
          activity_date: {
            state: true,
            value: '-1',
            title: 'Activity Date',
            order: 0,
          },
          data_type: {
            state: false,
            value: '1',
            title: 'Activity Type',
            order: 1,
          },
          num_points: {
            state: false,
            value: '1',
            title: 'Activity Points',
            order: 2,
          },
        },
      };
    };

    const petIdListener = $rootScope.$watch('adminPet', () => {
      if ($rootScope.adminPet) {
        if ($scope.tabId !== 'pet-information') {
          $scope.tabId = 'pet-information';
          $scope.petDetailTabChanges(null, $scope.tabId);
        }
        $scope.setTable();
        $timeout(() => {
          $scope.get_pet_information();
          $scope.get_medical_information();
          $scope.get_provider_information();
        }, 100);
      } else {
        $scope.clearPetDetail();
      }
    });

    $scope.showPetActionMenu = () => {
      $scope.isPetActionMenu = !$scope.isPetActionMenu;
    };

    $scope.isArray = (value) => {
      return Array.isArray(value);
    };

    $scope.get_pet_information = async () => {
      $scope.getStatuses().then((res) => {
        angular.forEach(res['pets-statuses'], (value) => {
          if (Boolean(value.value) === $rootScope.adminPet.is_active) {
            $scope.pet_information.status.value = value.name;
          }
        });
      });
      $scope.getGenders().then((res) => {
        angular.forEach(res['pets-gender'], (value) => {
          if (Boolean(value.value) === $rootScope.adminPet.is_male) {
            $scope.pet_information.gender.value = value.name;
          }
        });
      });
      $scope
        .getSpecies($http, ENV, {
          paginate: false,
        })
        .then((res) => {
          angular.forEach(res['pets-species'], (value) => {
            if (value.id === $rootScope.adminPet.species) {
              $scope.pet_information.species.value = value.name;
            }
          });
        });

      angular.forEach($scope.originalBreedList, (value) => {
        if (value.id === $rootScope.adminPet.breed) {
          $scope.pet_information.breed.value = value.name;
        }
      });
      $scope.pet_information.date_created.value = $rootScope.adminPet.date_created;
      $scope.pet_information.date_updated.value = $rootScope.adminPet.petprofile.date_updated;
      $scope.pet_information.date_of_birth.value = $rootScope.adminPet.date_of_birth;
      $scope.pet_information.age.value = Math.floor($rootScope.adminPet.age / 12);
      $scope.pet_information.human_age.value = $rootScope.adminPet.human_age;
      $scope.pet_information.lifestage.value = $rootScope.adminPet.lifestage;
      $scope.pet_information.adoption_date.value = $rootScope.adminPet.adoption_date;
    };

    $scope.get_medical_information = async () => {
      if ($rootScope.adminPet.is_male) {
        $scope.getNeutered().then((res) => {
          angular.forEach(res['pets-neutered'], (value) => {
            if (value.value === $rootScope.adminPet.petprofile.sterilized) {
              $scope.medical_information.sterilized.value = value.name;
            }
          });
        });
      } else {
        $scope.getSpayed().then((res) => {
          angular.forEach(res['pets-spayed'], (value) => {
            if (value.value === $rootScope.adminPet.petprofile.sterilized) {
              $scope.medical_information.sterilized.value = value.name;
            }
          });
        });
      }
      await $scope.getMedicalConditionOptions($http, ENV).then((res) => {
        $scope.medical_information.medical_conditions.value = [];
        $scope.medical_information.family_medical_conditions.value = [];
        $scope.medical_information.owner_identification.value = [];
        angular.forEach(res['pets-medical-conditions'], (value) => {
          if ($rootScope.adminPet.petprofile.medical_conditions.includes(value.value)) {
            $scope.medical_information.medical_conditions.value.push({
              label: null,
              value: value.name,
            });
          }
          if ($rootScope.adminPet.petprofile.family_medical_conditions.includes(value.value)) {
            $scope.medical_information.family_medical_conditions.value.push({
              label: null,
              value: value.name,
            });
          }
        });
      });
      if ($rootScope.adminPet.petprofile.medical_condition_other_info) {
        $scope.medical_information.medical_conditions.value.push({
          label: null,
          value: $rootScope.adminPet.petprofile.medical_condition_other_info,
        });
      }
      if ($rootScope.adminPet.petprofile.family_medical_condition_other_info) {
        $scope.medical_information.family_medical_conditions.value.push({
          label: null,
          value: $rootScope.adminPet.petprofile.family_medical_condition_other_info,
        });
      }
      await $scope.getOwnerIdentifications().then((res) => {
        angular.forEach(res['pets-owner-identifications'], (value) => {
          if ($rootScope.adminPet.petprofile[value.value]) {
            $scope.medical_information.owner_identification.value.push({
              label: null,
              value: value.name,
            });
          }
        });
        $scope.medical_information.owner_identification.value = uniqBy(
          $scope.medical_information.owner_identification.value,
          'value',
        );
      });
      if ($rootScope.adminPet.petprofile.id_other_info) {
        $scope.medical_information.owner_identification.value.push({
          label: null,
          value: $rootScope.adminPet.petprofile.id_other_info,
        });
        $scope.medical_information.owner_identification.value = uniqBy(
          $scope.medical_information.owner_identification.value,
          'value',
        );
      }

      if ($rootScope.adminPet.petprofile.declawed !== null && $rootScope.adminPet.species === 2) {
        // get declawed options from redux and find matching label for value
        // declawed values = null (not set), '' (not declawed), 'F' (front paws), 'R' (rear paws), and 'FR' (all paws)
        $scope.getDeclawedOptions().then(({ petsDeclawedOptions = [] }) => {
          $scope.medical_information.declawed.value = petsDeclawedOptions.find(
            ({ value }) => value === $rootScope.adminPet.petprofile.declawed,
          )?.name;
        });
      }
      $scope.medical_information.notes.value = $rootScope.adminPet.clinic_tag;
      $scope.medical_information.weight.value = $rootScope.adminPet.weight;
    };

    $scope.get_provider_information = async () => {
      $scope.provider_information = [];
      angular.forEach($rootScope.adminPet.providers, (value) => {
        $scope.provider_information.push({
          label: value.name,
          value: value.organization,
        });
      });
    };

    $scope.getProfileImage = (src) => {
      if (src) {
        return src;
      }

      if (!$rootScope.adminPet) {
        return '';
      }

      return `/images/default-${
        $rootScope.adminPet.species === 1 ? 'canine' : 'feline'
      }-profile.png`;
    };

    $(document).on('click', (event) => {
      const settingEle = $('.header-actions');

      if (settingEle !== event.target && !settingEle.has(event.target).length) {
        $scope.$apply(() => {
          $scope.isPetActionMenu = false;
        });
      }
    });

    $scope.init();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      petIdListener();
      $scope.clearPetDetail();
      if (!$rootScope.isUserPage) {
        $rootScope.userId = null;
      }
    });
  })
  .directive('petDetail', () => {
    return {
      templateUrl: 'templates/v2/pet-detail.html',
    };
  });
